import { render, staticRenderFns } from "./YoastSeo.vue?vue&type=template&id=e145d9cc"
import script from "./YoastSeo.vue?vue&type=script&lang=js"
export * from "./YoastSeo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports